export const getLoading = (state) => state.isLoading;
export const getErrorResponse = (state) => state.errorResponse;
export const getSuccessResponse = (state) => state.successResponse;
